type Listener = (...args: any[]) => void

export class EventEmitter {
  private listeners: { [event: string]: Listener[] } = {}

  on(event: string, listener: Listener): void {
    if (!this.listeners[event]) {
      this.listeners[event] = []
    }
    this.listeners[event].push(listener)
  }

  off(event: string, listener: Listener): void {
    if (this.listeners[event]) {
      this.listeners[event] = this.listeners[event].filter(
        (l) => l !== listener
      )
    }
  }

  emit(event: string, ...args: any[]): void {
    const eventListeners = this.listeners[event]
    if (eventListeners) {
      eventListeners.forEach((listener) => listener(...args))
    }
  }
}
